module.exports = __webpack_public_path__ + "static/media/resplandor-bella-señora.a60885d9.png";